import {Component, Input, ViewEncapsulation} from '@angular/core';
import {WebPlayerUrls} from '../../web-player-urls.service';
import {Snip} from '../../../models/Snip';
import {Snips} from '../snips.service';
import {Player} from '../../player/player.service';
import {queueId} from '../../player/queue-id';

@Component({
    selector: 'snip-item',
    templateUrl: './snip-item.component.html',
    styleUrls: ['./snip-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {'class': 'media-grid-item', '[class.active]': 'playing()'},
})
export class SnipItemComponent {
    @Input() snip: Snip;
    @Input() scrollContainer: HTMLElement;
    @Input() disablePlayback = false;

    constructor(
        public urls: WebPlayerUrls,
        private snips: Snips,
        private player: Player,
    ) {}

    public playing() {
        return this.player.mediaItemPlaying(this.queueId());
    }

    public play() {
        this.player.playMediaItem(this.queueId());
    }

    public pause() {
        this.player.pause();
    }

    public queueId() {
        return queueId(this.snip);
    }
}
